export enum DownloadExcelType {
  excel,
  accreditation,
}
